import React from "react";
import { Wrapper, Text } from "./styledComponents";

import Modal from "components/Modal";

const VerificationResentSuccessModal = ({ close }) => (
  <Modal close={close} title="Uh Oh!">
    <Wrapper>
      <Text>
        An Error has occured. Please try again or <a href='https://help.mvbth.com'
        target="_blank" rel="noreferrer noopener"
        name="Help">contact support</a> for help.
      </Text>
    </Wrapper>
  </Modal>
);

export default VerificationResentSuccessModal;



// WEBPACK FOOTER //
// ./src/components/VerificationResentFailureModal/index.js